export const CheckAll = [
  {
    ids: 22086,
    name: '萧山区人民法院',
    value: 22086,
    clabel: '萧山区人民法院',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22109,
    name: '萧山区人民检察院',
    value: 22109,
    clabel: '萧山区人民检察院',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22128,
    name: '萧山区总工会',
    value: 22128,
    clabel: '萧山区总工会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22139,
    name: '共青团杭州市萧山区委',
    value: 22139,
    clabel: '共青团杭州市萧山区委',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22147,
    name: '萧山区妇联',
    value: 22147,
    clabel: '萧山区妇联',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22153,
    name: '萧山区科学技术协会',
    value: 22153,
    clabel: '萧山区科学技术协会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22160,
    name: '萧山区文联',
    value: 22160,
    clabel: '萧山区文联',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22164,
    name: '萧山区残疾人联合会',
    value: 22164,
    clabel: '萧山区残疾人联合会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22172,
    name: '萧山区红十字会',
    value: 22172,
    clabel: '萧山区红十字会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22175,
    name: '萧山区工商业联合会',
    value: 22175,
    clabel: '萧山区工商业联合会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23623,
    name: '国家统计局萧山调查队',
    value: 23623,
    clabel: '国家统计局萧山调查队',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23618,
    name: '萧山区邮政管理局',
    value: 23618,
    clabel: '萧山区邮政管理局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23605,
    name: '萧山区气象局',
    value: 23605,
    clabel: '萧山区气象局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23611,
    name: '萧山区消防救援大队',
    value: 23611,
    clabel: '萧山区消防救援大队',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23597,
    name: '萧山区烟草专卖局',
    value: 23597,
    clabel: '萧山区烟草专卖局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23561,
    name: '萧山区税务局',
    value: 23561,
    clabel: '萧山区税务局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23552,
    name: '萧山日报社',
    value: 23552,
    clabel: '萧山日报社',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23538,
    name: '萧山区融媒体中心',
    value: 23538,
    clabel: '萧山区融媒体中心',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23531,
    name: '萧山区矛调中心',
    value: 23531,
    clabel: '萧山区矛调中心',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23524,
    name: '萧山区档案馆',
    value: 23524,
    clabel: '萧山区档案馆',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23517,
    name: '萧山区红山农场',
    value: 23517,
    clabel: '萧山区红山农场',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23507,
    name: '萧山区金融控股集团',
    value: 23507,
    clabel: '萧山区金融控股集团',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23459,
    name: '萧山区交投集团',
    value: 23459,
    clabel: '萧山区交投集团',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23406,
    name: '萧山区城投集团',
    value: 23406,
    clabel: '萧山区城投集团',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23372,
    name: '萧山区环境集团',
    value: 23372,
    clabel: '萧山区环境集团',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23360,
    name: '萧山区国资经营集团',
    value: 23360,
    clabel: '萧山区国资经营集团',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23352,
    name: '公积金萧山分中心',
    value: 23352,
    clabel: '公积金萧山分中心',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23346,
    name: '杭州湘湖（白马湖）研究院',
    value: 23346,
    clabel: '杭州湘湖（白马湖）研究院',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23329,
    name: '杭州南站新城管理委员会',
    value: 23329,
    clabel: '杭州南站新城管理委员会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23317,
    name: '萧山区供销联社',
    value: 23317,
    clabel: '萧山区供销联社',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23311,
    name: '萧山区交易中心',
    value: 23311,
    clabel: '萧山区交易中心',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23283,
    name: '萧山区审管办',
    value: 23283,
    clabel: '萧山区审管办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23276,
    name: '党校萧山分校',
    value: 23276,
    clabel: '党校萧山分校',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23270,
    name: '萧山区委党研室（区志办）',
    value: 23270,
    clabel: '萧山区委党研室（区志办）',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23263,
    name: '萧山区人武部',
    value: 23263,
    clabel: '萧山区人武部',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23234,
    name: '萧山区盈丰街道',
    value: 23234,
    clabel: '萧山区盈丰街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23199,
    name: '萧山区南阳街道',
    value: 23199,
    clabel: '萧山区南阳街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23165,
    name: '萧山区靖江街道',
    value: 23165,
    clabel: '萧山区靖江街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23129,
    name: '萧山区新街街道',
    value: 23129,
    clabel: '萧山区新街街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23104,
    name: '萧山区宁围街道',
    value: 23104,
    clabel: '萧山区宁围街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23077,
    name: '萧山区闻堰街道',
    value: 23077,
    clabel: '萧山区闻堰街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23019,
    name: '萧山区新塘街道',
    value: 23019,
    clabel: '萧山区新塘街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22975,
    name: '萧山区蜀山街道',
    value: 22975,
    clabel: '萧山区蜀山街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22918,
    name: '萧山区北干街道',
    value: 22918,
    clabel: '萧山区北干街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22869,
    name: '萧山区城厢街道',
    value: 22869,
    clabel: '萧山区城厢街道',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22680,
    name: '萧山区瓜沥镇',
    value: 22680,
    clabel: '萧山区瓜沥镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22649,
    name: '萧山区衙前镇',
    value: 22649,
    clabel: '萧山区衙前镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22611,
    name: '萧山区义桥镇',
    value: 22611,
    clabel: '萧山区义桥镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22571,
    name: '萧山区所前镇',
    value: 22571,
    clabel: '萧山区所前镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22528,
    name: '萧山区进化镇',
    value: 22528,
    clabel: '萧山区进化镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22493,
    name: '萧山区浦阳镇',
    value: 22493,
    clabel: '萧山区浦阳镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22445,
    name: '萧山区临浦镇',
    value: 22445,
    clabel: '萧山区临浦镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22405,
    name: '萧山区戴村镇',
    value: 22405,
    clabel: '萧山区戴村镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22375,
    name: '萧山区河上镇',
    value: 22375,
    clabel: '萧山区河上镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22349,
    name: '萧山区楼塔镇',
    value: 22349,
    clabel: '萧山区楼塔镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21980,
    name: '萧山区投促局',
    value: 21980,
    clabel: '萧山区投促局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21990,
    name: '市规划资源局萧山分局',
    value: 21990,
    clabel: '市规划资源局萧山分局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22028,
    name: '市医保局萧山分局',
    value: 22028,
    clabel: '市医保局萧山分局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22034,
    name: '市生态环境局萧山分局',
    value: 22034,
    clabel: '市生态环境局萧山分局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22051,
    name: '萧山区机关事务服务中心',
    value: 22051,
    clabel: '萧山区机关事务服务中心',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21923,
    name: '萧山区综合行政执法局',
    value: 21923,
    clabel: '萧山区综合行政执法局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21911,
    name: '萧山区统计局',
    value: 21911,
    clabel: '萧山区统计局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21905,
    name: '萧山区金融办',
    value: 21905,
    clabel: '萧山区金融办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21854,
    name: '萧山区市场监管局',
    value: 21854,
    clabel: '萧山区市场监管局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21842,
    name: '萧山区审计局',
    value: 21842,
    clabel: '萧山区审计局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21834,
    name: '萧山区退役军人事务局',
    value: 21834,
    clabel: '萧山区退役军人事务局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21818,
    name: '萧山区应急管理局',
    value: 21818,
    clabel: '萧山区应急管理局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21739,
    name: '萧山区卫生健康局',
    value: 21739,
    clabel: '萧山区卫生健康局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21712,
    name: '萧山区文旅局',
    value: 21712,
    clabel: '萧山区文旅局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21696,
    name: '萧山区商务局',
    value: 21696,
    clabel: '萧山区商务局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21640,
    name: '萧山区农业农村局',
    value: 21640,
    clabel: '萧山区农业农村局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21594,
    name: '萧山区交通运输局',
    value: 21594,
    clabel: '萧山区交通运输局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21551,
    name: '萧山区住房和城乡建设局',
    value: 21551,
    clabel: '萧山区住房和城乡建设局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21487,
    name: '萧山区人力社保局',
    value: 21487,
    clabel: '萧山区人力社保局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21461,
    name: '萧山区财政局',
    value: 21461,
    clabel: '萧山区财政局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21423,
    name: '萧山区司法局',
    value: 21423,
    clabel: '萧山区司法局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21405,
    name: '萧山区民政局',
    value: 21405,
    clabel: '萧山区民政局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21321,
    name: '萧山区公安分局',
    value: 21321,
    clabel: '萧山区公安分局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 21313,
    name: '萧山区科技局',
    value: 21313,
    clabel: '萧山区科技局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20590,
    name: '萧山区教育局',
    value: 20590,
    clabel: '萧山区教育局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20577,
    name: '萧山区经济和信息化局',
    value: 20577,
    clabel: '萧山区经济和信息化局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20558,
    name: '萧山区发改局',
    value: 20558,
    clabel: '萧山区发改局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20509,
    name: '萧山区信访局',
    value: 20509,
    clabel: '萧山区信访局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20502,
    name: '萧山区委老干部局',
    value: 20502,
    clabel: '萧山区委老干部局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20495,
    name: '萧山区委巡察办',
    value: 20495,
    clabel: '萧山区委巡察办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20487,
    name: '萧山区委编办',
    value: 20487,
    clabel: '萧山区委编办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20474,
    name: '萧山区委政法委',
    value: 20474,
    clabel: '萧山区委政法委',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20469,
    name: '萧山区委统战部',
    value: 20469,
    clabel: '萧山区委统战部',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20442,
    name: '萧山区委宣传部',
    value: 20442,
    clabel: '萧山区委宣传部',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20431,
    name: '萧山区委组织部',
    value: 20431,
    clabel: '萧山区委组织部',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20375,
    name: '萧山区纪委区监委',
    value: 20375,
    clabel: '萧山区纪委区监委',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20374,
    name: '萧山区委改革办',
    value: 20374,
    clabel: '萧山区委改革办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 40012,
    name: '萧山区城市智治中心',
    value: 40012,
    clabel: '萧山区城市智治中心',
    isChecked: false,
    disabled: false
  },

  {
    ids: 22836,
    name: '萧山区党湾镇',
    value: 22836,
    clabel: '萧山区党湾镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22776,
    name: '萧山区益农镇',
    value: 22776,
    clabel: '萧山区益农镇',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22331,
    name: '钱江世纪城管委会',
    value: 22331,
    clabel: '钱江世纪城管委会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22292,
    name: '湘湖国家旅游度假区管委会',
    value: 22292,
    clabel: '湘湖国家旅游度假区管委会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22271,
    name: '杭州临空经济示范区管委会',
    value: 22271,
    clabel: '杭州临空经济示范区管委会',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22182,
    name: '萧山经济技术开发区管委会',
    value: 22182,
    clabel: '萧山经济技术开发区管委会',
    isChecked: false,
    disabled: false
  },

  {
    ids: 40009,
    name: '萧山区侨联',
    value: 40009,
    clabel: '萧山区侨联',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20549,
    name: '萧山区数据资源管理局',
    value: 20549,
    clabel: '萧山区数据资源管理局',
    isChecked: false,
    disabled: false
  },
  {
    ids: 22067,
    name: '萧山区政协办',
    value: 22067,
    clabel: '萧山区政协办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23638,
    name: '浙江银保监局萧山监管组',
    value: 23638,
    clabel: '浙江银保监局萧山监管组',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23637,
    name: '人民银行萧山支行',
    value: 23637,
    clabel: '人民银行萧山支行',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23604,
    name: '海关驻萧山办事处',
    value: 23604,
    clabel: '海关驻萧山办事处',
    isChecked: false,
    disabled: false
  },

  {
    ids: 23591,
    name: '国网萧山供电公司',
    value: 23591,
    clabel: '国网萧山供电公司',
    isChecked: false,
    disabled: false
  },
  {
    ids: 20521,
    name: '萧山区人大办',
    value: 20521,
    clabel: '萧山区人大办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 39990,
    name: '萧山区疫情防控办',
    value: 39990,
    clabel: '萧山区疫情防控办',
    isChecked: false,
    disabled: false
  },
  {
    ids: 23628,
    name: '移动萧山分公司',
    value: 23628,
    clabel: '移动萧山分公司',
    isChecked: false,
    disabled: false
  }
];
